module.exports = __webpack_public_path__ + "img/open-menu.f107bd7f.svg";